import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import no from "./locales/no.json"

const messages = {
  en,
  no,
}

// Saved preference wins; first launch falls back to the device language so an
// international user (or store reviewer) doesn't open into a Norwegian UI.
function detectLanguage(): "en" | "no" {
  const stored = localStorage.getItem("language")
  if (stored === "en" || stored === "no") return stored
  const device = (navigator.language ?? "").toLowerCase()
  // Norwegian device locales: nb (bokmål), nn (nynorsk), no (generic)
  return /^(nb|nn|no)(-|$)/.test(device) ? "no" : "en"
}
const savedLanguage = detectLanguage()

// Keep <html lang> in sync so screen readers pick the right voice for the UI
// language ("no" covers both bokmål and nynorsk UI strings).
function applyDocumentLanguage(locale: "en" | "no") {
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale
  }
}
applyDocumentLanguage(savedLanguage)

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: "en",
  messages,
  globalInjection: true,
})

export { i18n }
export default i18n

// Helper function to switch language and save to localStorage
export function switchLanguage(locale: "en" | "no") {
  i18n.global.locale.value = locale
  localStorage.setItem("language", locale)
  applyDocumentLanguage(locale)
}

// Helper function to get current language
export function getCurrentLanguage() {
  return i18n.global.locale.value
}
